<div class="modal fade" id="editAddModal-1" tabindex="-1" aria-labelledby="exampleEditAddAcLineModalLabel" aria-hidden="true"  (hidden.bs.modal)="resetForm()">
  <div style="max-width: 64rem;" class="modal-dialog modal-dialog-centered modal-lg">
    <form (ngSubmit)="save()"   
      style="border-radius: 20px;" class="modal-content rounded-5 shadow-lg border-0">
      <div class="modal-header border-0 pb-0">
        <h5 style="font-size: 2rem;" class="modal-title fw-semibold" id="exampleEditAddAcLineModalLabel">{{ isEdit ? "Update AC Line Segment" : "Add New AC Line Segment" }}</h5>
        <button type="button" style="border: none; background: transparent;" data-bs-dismiss="modal" aria-label="Zatvori">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#171717" fill-opacity="0.05"/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#171717" stroke-opacity="0.07"/>
            <path d="M8.375 8.375L15.625 15.625M15.625 8.375L8.375 15.625" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <p class="description-text">{{ isEdit ? "Fill out the fields carefully to update this instance, including all necessary information for identification." : "Fill out the fields carefully to create a new instance, including all necessary information for identification." }}</p>
        <div 
          class="new-instance-modal-body modal-body pt-3 m-0 w-100 align-items-center justify-content-between">
          
          <!-- <div *ngIf="!isOpenedFromSubstation" class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Instance Category</p>
            </div>
            <div class="col-6">
              <lib-enum-dropdown
                [enumObject]="AcLineType"
                [initialValue]="initialAcLineType"
                (valueChange)="onAcLineSegmentTypeChanged($event)"
                [disabled]="true"
                #instanceCategoryDropdown
              ></lib-enum-dropdown>
            </div>
          </div> -->
          
          <div *ngIf="!isOpenedFromSubstation" class="section w-100 row">
            <ng-container>
              <div class="label-div d-flex align-items-center justify-content-left col-6">
                <p>Parent Class (Substation)</p>
              </div>
              <div class="col-6">
                <lib-object-dropdown
                    [items]="substationTemplateOptions"
                    [displayField]="'className'" 
                    [initialValue]="substationTemplateValue"
                    (valueChange)="onSelectSubstationTemplate($event)"
                    [disabled]="isBoundary && isEdit"
                    [isRequired]="true"
                    #parentSubstationDropdown
                ></lib-object-dropdown>
              </div>
              <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                <p>Asset Name</p>
              </div>
              <div class="col-6 ac-line-asset-spacing" [ngClass]="{ 'disabled': selectedSubstationTemplate === 0 }">
                <lib-object-dropdown
                  [items]="substationOptions"
                  [displayField]="'name'" 
                  [initialValue]="substationTemplateInstanceValue"
                  (valueChange)="onSelectSubstationTemplateInstance($event, undefined, true)"
                  [disabled]="isBoundary && isEdit"
                  [isRequired]="true"
                  [isSearchEnabled]="true"
                  [maxDisplayItemSize]="10"
                  (searchTextChange)="onSearchTextChange($event)"
                  #assetNameDropdown
                ></lib-object-dropdown>
              </div>
              <ng-container *ngIf="isBoundary">
                <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                  <p>Parent AC Line</p>
                </div>
                <div class="col-6 ac-line-asset-spacing" *ngIf="!isEdit" [ngClass]="{ 'disabled': selectedSubstationTemplate === 0 }">
                  <lib-object-dropdown
                    [items]="parentAcLineOptions"
                    [displayField]="'name'" 
                    [initialValue]="parentAcLineInstanceValue"
                    (valueChange)="onSelectParentAcLineInstance($event)"
                    [disabled]="false"
                    [isRequired]="true"
                    [isSearchEnabled]="true"
                    [maxDisplayItemSize]="10"
                    (searchTextChange)="onSearchTextChange($event)"
                    #parentAcLineDropdown
                  ></lib-object-dropdown>
                </div>
                <div *ngIf="isEdit" class="col-6 ac-line-asset-spacing">
                  <input
                    class="new-instance-input w-100" 
                    type="text" 
                    [value]="acLineName ?? ''"
                    disabled
                    placeholder=" "
                  />
                </div>
              </ng-container>
              <ng-container *ngIf="!isBoundary">
                <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                  <p>Power Transformer</p>
                </div>
                <div class="col-6 ac-line-asset-spacing">
                  <lib-object-dropdown
                      [items]="powerTransformerOptions"
                      [displayField]="'name'" 
                      [initialValue]="powerTransformerInitialValue"
                      (valueChange)="onSelectPowerTransformer($event)"
                      [disabled]="false"
                      [isRequired]="true"
                      #powerTransformerDropdown
                  ></lib-object-dropdown>
                </div>
              </ng-container>
          
              <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                <p>Base Voltage</p>
              </div>
              <div class="col-6 ac-line-asset-spacing disabled">
                <input 
                  class="new-instance-input w-100 disabled"
                  name="baseVoltage"
                  [value]="displayBaseVoltage ? baseVoltage : ''"
                  placeholder=" "  
                  type="text"
                  disabled
                />
              </div>
              <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                <p>Meter Number</p>
              </div>
              <div class="col-6 ac-line-asset-spacing">
                <input 
                  class="new-instance-input w-100"
                  name="meterNumber"
                  [(ngModel)]="selectedAcLineSegment.meterNumber"
                  placeholder=" "  
                  type="text"
                />
              </div>

              <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                <p>Meter Brand</p>
              </div>
              <div class="col-6 ac-line-asset-spacing">
                <lib-object-dropdown
                    [items]="meterBrands"
                    [displayField]="'name'"
                    [initialValue]="meterBrandValue"
                    (valueChange)="onSelectMeterBrand($event)"
                    [disabled]="false"
                    [placeholder]="'Select Meter Brand'"
                    #meterBrandDropdown
                ></lib-object-dropdown>
              </div>

              <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                <p>Latitude</p>
              </div>
              <div class="col-6 ac-line-asset-spacing">
                <input 
                  class="new-instance-input w-100"
                  name="latitude"
                  [(ngModel)]="selectedAcLineSegment.latitude"
                  placeholder=" "  
                  type="number"
                />
              </div>

              <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                <p>Longitude</p>
              </div>
              <div class="col-6 ac-line-asset-spacing">
                <input 
                  class="new-instance-input w-100"
                  name="longitude"
                  [(ngModel)]="selectedAcLineSegment.longitude"
                  placeholder=" "  
                  type="number"
                />
              </div>
            </ng-container>
          </div>
          
          <!-- Instance Name - uvek isti -->
          <div *ngIf="!isOpenedFromSubstation" class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Instance Name</p>
            </div>
            <div class="col-6 ac-line-asset-spacing">
              <input 
                class="new-instance-input w-100" 
                type="text" 
                name="instanceName"
                [(ngModel)]="selectedAcLineSegment.name"
                placeholder=" "  
              />
            </div>
          </div>
          
          <!-- Number - uvek isti -->
          <div *ngIf="!isOpenedFromSubstation" class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Number</p>
            </div>
            <div class="col-6">
              <input 
                class="new-instance-input w-100" 
                name="number"
                [(ngModel)]="selectedAcLineSegment.number"
                placeholder=" "  
                type="text"
              />
            </div>
          </div>
          <div *ngIf="!isOpenedFromSubstation && hasBand" class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                <p>Feeder Band</p>
            </div>
            <div class="col-6 ac-line-asset-spacing">
              <lib-object-dropdown
                  [items]="bandOptions"
                  [displayField]="'name'"
                  [initialValue]="selectedBandOption"
                  (valueChange)="onSelectFeederBand($event)"
                  [disabled]="false"
                  #feederBandDropdown
              ></lib-object-dropdown>
            </div>
            <ng-container *ngIf="feederBandChanged">
              <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                  <p>Customer Type</p>
              </div>
              <div class="col-6 ac-line-asset-spacing">
                <lib-object-dropdown
                    [items]="customerTariffOptions"
                    [displayField]="'name'"
                    [initialValue]="selectedCustomerTariffOption"
                    (valueChange)="onSelectCustomerTariff($event)"
                    [disabled]="false"
                    [isRequired]="true"
                    #customerTariffDropdown
                ></lib-object-dropdown>
              </div>
            </ng-container>
          </div>
          <!-- Region - uvek isti -->
          <div *ngIf="!isOpenedFromSubstation" class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Supplied Regions</p>
            </div>
            <div class="col-6">
              <input 
                class="new-instance-input w-100 disabled"
                name="region"
                [value]="editModeRegion ?? '---'"
                placeholder=" "  
                type="text"
                disabled
              />
            </div>
          </div>

          <!-- EDIT from Substation details -->
            <ng-container *ngIf="isOpenedFromSubstation">

              <div class="section w-100 row">
                <div class="label-div d-flex align-items-center justify-content-left col-6">
                  <p>Line Category</p>
                </div>
                <div class="col-6">
                  <lib-enum-dropdown
                    [enumObject]="AcLineType"
                    [initialValue]="initialAcLineType"
                    (valueChange)="onAcLineSegmentTypeChanged($event)"
                    #instanceCategoryDropdown
                  ></lib-enum-dropdown>
                </div>
              </div>

              <div class="section w-100 row">

                <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                  <p>AC Line Name</p>
                </div>
                <div class="col-6 ac-line-asset-spacing">
                  <input 
                    class="new-instance-input w-100" 
                    type="text" 
                    name="instanceName"
                    [(ngModel)]="selectedAcLineSegment.name"
                    placeholder=" "  
                  />
                </div>

                <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                  <p>Number</p>
                </div>
                <div class="col-6 ac-line-asset-spacing">
                  <input 
                    class="new-instance-input w-100" 
                    name="number"
                    [(ngModel)]="selectedAcLineSegment.number"
                    placeholder=" "  
                    type="text"
                  />
                </div>

              </div>

              <div class="section w-100 row">
                <ng-container *ngIf="!isBoundary">
                  <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                    <p>Power Transformer</p>
                  </div>

                  <div *ngIf="!isEdit" class="col-6 ac-line-asset-spacing">
                    <lib-object-dropdown
                        [items]="powerTransformerOptions"
                        [displayField]="'name'" 
                        [initialValue]="powerTransformerInitialValue"
                        (valueChange)="onSelectPowerTransformer($event)"
                        [disabled]="false"
                        [isRequired]="true"
                        #powerTransformerDropdown
                    ></lib-object-dropdown>
                  </div>

                  <div *ngIf="isEdit" class="col-6 ac-line-asset-spacing">
                    <input
                      class="new-instance-input w-100" 
                      type="text" 
                      [value]="powerTransformerName ?? ''"
                      disabled
                      placeholder=" "
                    />
                  </div>
                </ng-container>
                <ng-container *ngIf="isBoundary">
                  <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                    <p>Parent AC Line</p>
                  </div>

                  <div *ngIf="!isEdit" class="col-6 ac-line-asset-spacing">
                    <lib-object-dropdown
                        [items]="parentAcLineOptions"
                        [displayField]="'name'" 
                        [initialValue]="parentAcLineInstanceValue"
                        (valueChange)="onSelectParentAcLineInstance($event)"
                        [disabled]="false"
                        [isRequired]="true"
                        #acLineDropdown
                    ></lib-object-dropdown>
                  </div>

                  <div *ngIf="isEdit" class="col-6 ac-line-asset-spacing">
                    <input
                      class="new-instance-input w-100" 
                      type="text" 
                      [value]="powerTransformerName ?? ''"
                      disabled
                      placeholder=" "
                    />
                  </div>
                </ng-container>

                <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                  <p>Base Voltage</p>
                </div>

                <div class="col-6 ac-line-asset-spacing disabled">
                  <input 
                    class="new-instance-input w-100 disabled"
                    name="baseVoltage"
                    [value]="displayBaseVoltage ? baseVoltage : ''"
                    placeholder=" "  
                    type="text"
                    disabled
                  />
                </div>
                <ng-container *ngIf="hasBand">
                  <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                      <p>Feeder Band</p>
                  </div>
                  <div class="col-6 ac-line-asset-spacing">
                    <lib-object-dropdown
                        [items]="bandOptions"
                        [displayField]="'name'"
                        [initialValue]="selectedBandOption"
                        (valueChange)="onSelectFeederBand($event)"
                        [disabled]="false"
                        #feederBandDropdown
                    ></lib-object-dropdown>
                  </div>
                  <ng-container *ngIf="feederBandChanged">
                    <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                        <p>Customer Tariff Update</p>
                    </div>
                    <div class="col-6 ac-line-asset-spacing">
                      <lib-object-dropdown
                          [items]="customerTariffOptions"
                          [displayField]="'name'"
                          [initialValue]="selectedCustomerTariffOption"
                          (valueChange)="onSelectCustomerTariff($event)"
                          [disabled]="false"
                          [isRequired]="true"
                          #customerTariffDropdown
                      ></lib-object-dropdown>
                    </div>
                  </ng-container>
                </ng-container>
                
              </div>
            </ng-container>
          
        </div>         
      <div class="modal-footer border-0">
        <button type="button" class="btn cancel-modal-btn" data-bs-dismiss="modal" #closeEditModal (click)="resetForm()">Cancel</button>
        <button type="submit" class="btn save-modal-btn">{{ isEdit ? 'Update' : 'Save' }}</button>
      </div>
    </form>
  </div>
</div>